import React, { Component } from 'react';
import { loadModules, setDefaultOptions } from 'esri-loader';
import axios from 'axios';

import {AddressBook, UserSchedule, EditAddress, EditEvent } from '../shared/fillmoreScenes';
import LoadSpinner from '../shared/loadSpinner';

var pointInt = null, activeWidget = null;


/* Images */
import baseImg from '../../assets/fillmore2.jpg';


class Fillmore extends Component{
    constructor(props) {
        super(props);
        this.state = {
            baseLng: -77.0902091,
            baseLat: 38.9977548,
            currentLocation:false,
            pointDict:{},
            sideStatus: false,
            sideSection: "schedule",
            sideSwap: false,
            editStatus: false,
            selectedItem: null,
            estimatedObj:{ type:"", pt:null, layer:[]},
            mapButton:null,
            loading: false
        }

        /* References */
        this.mapRef = React.createRef();

        this.selMapButton = this.selMapButton.bind(this);
        this.cleanMap = this.cleanMap.bind(this);
        this.changeSideSlide = this.changeSideSlide.bind(this);
        this.toggleMapPoint = this.toggleMapPoint.bind(this);
        this.addMapPt = this.addMapPt.bind(this);
        this.removeMapPt = this.removeMapPt.bind(this);
        this.getCurrentLocation = this.getCurrentLocation.bind(this);
        this.loadMaps = this.loadMaps.bind(this);
        this.toggleSide = this.toggleSide.bind(this);
        this.handleEditorChange = this.handleEditorChange.bind(this);
        this.newSelectedItem = this.newSelectedItem.bind(this);
        this.resetSliders = this.resetSliders.bind(this);
        this.estimateLocation = this.estimateLocation.bind(this);
    }

    selMapButton(type){
        var self = this;
        try {
            type = (self.state.mapButton === type ? null : type);
            self.setState({ mapButton: type }, ()=> {
                loadModules(["esri/widgets/DistanceMeasurement2D","esri/widgets/AreaMeasurement2D"])
                .then(([DistanceMeasurement2D, AreaMeasurement2D]) => {
                    if (activeWidget) {
                        self.view.ui.remove(activeWidget);
                        activeWidget.destroy();
                        activeWidget = null;
                    }

                    if(self.state.mapButton != null){
                        if(self.state.mapButton == "distance"){ activeWidget = new DistanceMeasurement2D({ view: self.view }); }
                        else { activeWidget = new AreaMeasurement2D({ view: self.view }); }

                        activeWidget.viewModel.newMeasurement();
                        self.view.ui.add(activeWidget, "bottom-right");
                    }
                });   
            });         
        }
        catch(ex){
            console.log("[Error] Selection Map Button: ",ex);
        }
    }

    cleanMap(){
        var self = this;
        try {
            this.graphicsLayer.removeAll();
            // Remove Point
            if(self.state.estimatedObj.type === "set"){
                self.removeMapPt(self.state.estimatedObj.pt);
            }
            else if(self.state.estimatedObj.type === "traveling") {
                self.state.estimatedObj.layer.forEach(function(layer){
                    self.map.remove(layer);
                });
            }

            clearInterval(pointInt);
            this.setState({ currentLocation:false, estimatedObj: { type:"", pt:null, layer:[]} });
        }
        catch(ex){
            console.log("[Error] cleaning map: ",ex);
        }
    }

    changeSideSlide(type){
        try {
            this.setState({ sideSection: type, selectedItem: null });
        }
        catch(ex){
            console.log("[Error] Changing Side: ",ex);
        }
    }

    toggleMapPoint(point, add, editData){
        try {
            if(add){
                this.addMapPt(point, "fillmore1");
                // Update selectedItem
                this.setState({ selectedItem: editData });
            }
            else {
                this.removeMapPt(point);
                // Clear selectedItem
                this.setState({ editStatus: false });
            }
        }
        catch(ex){
            console.log("[Error] Toggling Point: ",ex);
        }
    }

    addMapPt(dataPoint, color){
        var self = this;
        try {
            if(dataPoint){
                var colorMap = { "background":[24, 25, 28], "fillmore1": [227, 101, 0], "fillmore2": [24, 129, 112] };

                loadModules(['esri/Graphic'])
                    .then(([Graphic]) => {
                        var tmpPointDict = self.state.pointDict;
                        var dataKey = dataPoint.lng + "|" + dataPoint.lat;

                        if(!(dataKey in tmpPointDict)){
                            var point = { type: "point", longitude: dataPoint.lng, latitude: dataPoint.lat };
                            var ptAttr = {
                                title:("title" in dataPoint ? dataPoint.title : ("name" in dataPoint ? dataPoint.name : "Location")),
                                address:("address" in dataPoint ? dataPoint.address : ""), city:("city" in dataPoint ? dataPoint.city : ""),
                                state:("state" in dataPoint ? dataPoint.state : ""), zip:("zip" in dataPoint ? dataPoint.zip : "")
                            };

                            var simpleMarkerSymbol = { type: "simple-marker",
                                color: (color in colorMap ? colorMap[color] : colorMap.fillmore1), outline: { color: [255, 255, 255], width: 1 }
                            };

                            var popupLoc = {
                                title: "{title}",
                                content: function () { return "{address}  {city}  {state} {zip}"; }
                            };

                            tmpPointDict[dataKey] = new Graphic({ 
                                geometry: point, 
                                symbol: simpleMarkerSymbol,
                                popupTemplate: popupLoc,
                                attributes: ptAttr
                            });

                            self.graphicsLayer.add(tmpPointDict[dataKey]);
                            
                            self.setState({ pointDict: tmpPointDict });
                        }
                    });
            }
        }
        catch(ex){
            console.log(" [Error] Adding Map Point: ", ex);
        }
    }

    removeMapPt(dataPoint){
        var self = this;
        try {
            if(dataPoint){
                loadModules(['esri/Graphic'])
                    .then(([Graphic]) => {
                        var tmpPointDict = self.state.pointDict;
                        var dataKey = dataPoint.lng + "|" + dataPoint.lat;

                        if(dataKey in tmpPointDict){
                            self.graphicsLayer.remove(tmpPointDict[dataKey]);

                            // Delete Key
                            delete tmpPointDict[dataKey];
                            self.setState({ pointDict: tmpPointDict });
                        }
                    });
            }
        }
        catch(ex){
            console.log(" [Error] Removing Map Point: ", ex);
        }
    }

    getCurrentLocation(){
        var self = this;
        try {
            navigator.geolocation.getCurrentPosition(function(position) {                
                self.setState({ currentLocation: true });
                self.addMapPt({ "lng":position.coords.longitude, "lat":position.coords.latitude, "title":"Current Location" }, "fillmore2");
                        
                // Recenter Map
                self.view.goTo({
                    center: [ position.coords.longitude, position.coords.latitude ],
                    zoom: 11
                }, { duration: 500 });    
            }, function(error) { console.log("Unable To Get Location From Browser")});
        }
        catch(ex){
            console.log("[Error] Getting Current Location: ",ex);
        }
    }

    loadMaps(lat, lng){
        var self = this;
        try {
            setDefaultOptions({ version: '4.18' });
            //setDefaultOptions({ version: '4.7' });

            var tmpLat = this.state.baseLat;
            var tmpLng = this.state.baseLng;
            var addPt = false;

            if(lat && lng){
                tmpLat = lat; tmpLng = lng;
                addPt = true;
                this.setState({ baseLat: lat, baseLng: lng });
            }

            loadModules(['esri/Map', 'esri/views/MapView', 'esri/layers/GraphicsLayer'], { css: true }) 
                .then(([ArcGISMap, MapView, GraphicsLayer]) => {
                    this.map = new ArcGISMap({ basemap: 'dark-gray' });
                    
                    this.graphicsLayer = new GraphicsLayer();
                    this.map.add(this.graphicsLayer);

                    this.view = new MapView({
                        container: self.mapRef.current,
                        map: this.map, center: [tmpLng, tmpLat],
                        zoom: 10, ui: { components: ["attribution"] }
                    });  

                    if(addPt){ self.addMapPt({"title":"Base Location",  "lng":tmpLng, "lat":tmpLat }, "fillmore2"); }
                });
        }
        catch(ex){
            console.log(" [Error] Loading Map: ",ex);
        }
    }

    toggleSide(type){
        try {
            this.setState({ [type]: !this.state[type] });
        }
        catch(ex){
            console.log(" [Error] toggling slider: ",ex);
        }
    }    

    handleEditorChange(e){
        try {
            var tmpItem = this.state.selectedItem;
            tmpItem[e.target.name] = e.target.value

            this.setState({ selectedItem: tmpItem })
        }
        catch(ex){
            console.log(" [Error] handling editor change: ",ex);
        }
    }

    newSelectedItem(item, status, swap){
        try {
            this.setState({ selectedItem: item, editStatus: status, sideSwap: swap });
        }
        catch(ex){
            console.log(" [Error] Adding Selected Item: ",ex);
        }
    }   
    
    resetSliders(side){
        var self = this;
        try {
            var defaultSide = this.state.sideSection; 
            this.setState({ editStatus: false, sideStatus: side, sideSection:"" }, ()=> {
                self.setState({ selectedItem: null, sideSection: defaultSide });
            });
        }
        catch(ex){
            console.log(" [Error] Adding Selected Item: ",ex);
        }
    }

    estimateLocation(user){
        var self = this;
        try {
            this.setState({ loading: true }, () => {
                // Remove Point
                clearInterval(pointInt);
                if(self.state.estimatedObj.type === "set"){
                    self.removeMapPt(self.state.estimatedObj.pt);
                }
                else {
                    self.state.estimatedObj.layer.forEach(function(layer){
                        self.map.remove(layer);
                    });
                }               

                var postData = { "user": user };

                axios.post(self.props.baseUrl + "/fillmore/location/estimate", postData, {'Content-Type': 'application/json'})
                .then(function(response) {
                    if(response.data.error){
                        console.log(" [Error] Getting User Estimated Location: ", response.data.error);
                        self.setState({ loading: false });
                    }
                    else {         
                        var dataRes = response.data.results;              
                        self.setState({ loading: false}, ()=> {
                            if(dataRes.type === "set"){
                                if(dataRes.info.info && dataRes.info.info.length > 0){
                                    dataRes.info.info[0].title = user.name + " Estimated Location";
                                    self.addMapPt(dataRes.info.info[0], "fillmore2");
                                    // Zoom to Location
                                    self.view.goTo({
                                        center: [ dataRes.info.info[0].lng, dataRes.info.info[0].lat ], zoom: 13
                                    }, { duration: 500 });
                                    self.setState({ estimatedObj: { type: "set", pt: dataRes.info.info[0]}});
                                }
                            }
                            else if(dataRes.type === "traveling") {
                                var removeInc = Math.ceil((dataRes.info.offsetTime * dataRes.info.path.length)/dataRes.info.time);
                                removeInc = (removeInc > dataRes.info.path.length ? dataRes.info.path.length - 2 : removeInc );

                                var pathRemain = dataRes.info.path.slice(removeInc);
                                var intTime = Math.floor(((dataRes.info.time - dataRes.info.offsetTime) * 60 * 1000) / pathRemain.length);

                                loadModules(["esri/Graphic", "esri/layers/GraphicsLayer","esri/geometry/Polyline", "esri/geometry/Point"], { css: true }) 
                                .then(([Graphic, GraphicsLayer, Polyline, Point]) => {
                                    
                                    var sls = {
                                        type: "simple-line", color: [24, 129, 112], width: "3px", style: "solid"
                                    };

                                    var pl = new Polyline({"paths": [dataRes.info.path], "spatialReference":{"wkid":4326}});
                                    var vechPath = new Graphic(pl, sls);

                                    var markerSymbol = { type: "simple-marker",
                                        color: [24, 129, 112], outline: { color: [255, 255, 255], width: 1 }
                                    };

                                    var gLayerVehicle = new GraphicsLayer({ "id": "Vehicle" });
                                    var gLayerVehiclePath = new GraphicsLayer({ "id": "VehiclePath" });

                                    self.map.addMany([gLayerVehiclePath, gLayerVehicle]);
                                    gLayerVehiclePath.add(vechPath);

                                    //Set Layers To Remove
                                    self.setState({ estimatedObj: { type: "traveling", layer: [gLayerVehiclePath, gLayerVehicle]}});

                                    // Zoom to Location
                                    if(pathRemain.length > 0){
                                        self.view.goTo({
                                            center: [ pathRemain[0][0], pathRemain[0][1] ], zoom: 13
                                        }, { duration: 500 });
                                    }

                                    var pathCount = 0; pointTrack();
                                    pointInt = setInterval(pointTrack, intTime);                                    

                                    function pointTrack(){
                                        gLayerVehicle.removeAll();
                                        var p1 = new Point(pathRemain[pathCount]);
                                        //var p2 = new Point(pathRemain[pathCount + 1]);

                                        var pt1Graphic = new Graphic(p1, markerSymbol);
                                        gLayerVehicle.add(pt1Graphic);

                                        pathCount++;
                                        if (pathCount >= pathRemain.length - 1) {
                                            clearInterval(pointInt);
                                        }
                                    }
                                });
                            }
                        });
                    }
                });    
            });
        }
        catch(ex){
            console.log("[Error] Estimating Location: ",ex);
        }
    }

    componentDidMount() {
        try {
            this.loadMaps(null, null);
        }
        catch(ex){
            console.log(" [Error]  Starting: ",ex);
        }
    }

    render(){   
        return(
            <div className="page-container fillmore-page">
                {this.state.loading && <LoadSpinner userClass="fillmore" /> }
                 <div className="page-panel title">
                    <div className="title-content">
                       <span>Fillmore</span>
                        
                        <div className="title-btn-container">
                            <div className="title-btn icon-btn alt" onClick={this.cleanMap}><i className="fas fa-broom" /></div>
                            {!this.state.currentLocation && <div className="title-btn icon-btn" alt="Current Location" onClick={this.getCurrentLocation}><i className="fas fa-street-view" /></div> }
                        </div>                        
                    </div>
                    <img className="title-img" src={baseImg} />
                </div>

                <div className="page-panel map-container">
                    <div className="arcMap" ref={this.mapRef} />
                    <div className="map-btn-container">
                        <div className={"map-btn" +(this.state.mapButton == "distance" ? " sel":"")} onClick={()=> this.selMapButton("distance")}><i className="fas fa-ruler" /></div>
                        <div className={"map-btn" +(this.state.mapButton == "area" ? " sel":"")} onClick={()=> this.selMapButton("area")}><i className="fas fa-draw-polygon" /></div>
                    </div>

                    <div className={"map-side" + (this.state.sideStatus ? " open" : "")}>
                        <div className="side-slider" onClick={() => this.toggleSide("sideStatus")}><i className={"fas " + (this.state.sideStatus ? "fa-angle-left" : "fa-angle-right")} /></div>
                        <div className="map-side-content">
                            <div className="slide-nav">
                                <div className={"nav-item" + (this.state.sideSection == "schedule" ? " sel":"")} onClick={()=>this.changeSideSlide("schedule")}>Schedules</div>
                                <div className={"nav-item" + (this.state.sideSection == "address" ? " sel":"")} onClick={()=>this.changeSideSlide("address")}>Address Book</div>
                                {/* <div className={"nav-item" + (this.state.sideSection == "directions" ? " sel":"")} onClick={()=>this.changeSideSlide("directions")}>Directions</div> */}
                            </div>

                            {/* Schedules */}
                            {this.state.sideSection == "schedule"  && <UserSchedule baseUrl={this.props.baseUrl} checkUser={this.props.checkUser} toggleMapPoint={this.toggleMapPoint} newSelectedItem={this.newSelectedItem} estimateLocation={this.estimateLocation} />}
                                
                            {/* Address Book */}
                            {this.state.sideSection == "address" && <AddressBook baseUrl={this.props.baseUrl} checkUser={this.props.checkUser} toggleMapPoint={this.toggleMapPoint} newSelectedItem={this.newSelectedItem} />}        
                        </div>
                    </div>

                    {this.state.selectedItem != null &&
                        <div className={"edit-side" + (this.state.editStatus ? " open" : "")}>
                            <div className="side-slider" onClick={() => this.toggleSide("editStatus")}><i className={"fas " + (this.state.editStatus ? "fa-times" : "fa-edit")} /></div>

                            <div className="edit-side-content">
                                {/* Schedules */}
                                {((this.state.sideSection == "schedule" && this.state.sideSwap == false) || (this.state.sideSwap == true && this.state.sideSection == "address")) && <EditEvent baseUrl={this.props.baseUrl} checkUser={this.props.checkUser} selectedItem={this.state.selectedItem} handleChange={this.handleEditorChange} resetSliders={this.resetSliders} addressSelection={this.newSelectedItem} /> }
                                {/* Address Book */}
                                {((this.state.sideSection == "address" && this.state.sideSwap == false)  || (this.state.sideSwap == true && this.state.sideSection == "schedule")) && <EditAddress baseUrl={this.props.baseUrl} checkUser={this.props.checkUser} selectedItem={this.state.selectedItem} handleChange={this.handleEditorChange} resetSliders={this.resetSliders} /> }
                            </div>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default Fillmore;